var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("p", { domProps: { innerHTML: _vm._s(_vm.formattedString) } }),
      _vm._v(" "),
      _vm.text.length > _vm.maxChars
        ? [
            !_vm.isReadMore
              ? _c(
                  "a",
                  {
                    staticClass: "read-more",
                    attrs: { id: "readmore", href: _vm.link },
                    on: {
                      click: function ($event) {
                        return _vm.triggerReadMore($event, true)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.more))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isReadMore
              ? _c(
                  "a",
                  {
                    staticClass: "read-more",
                    attrs: { id: "readmore", href: _vm.link },
                    on: {
                      click: function ($event) {
                        return _vm.triggerReadMore($event, false)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.less))]
                )
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }